import { HttpErrorResponse } from '@angular/common/http';

/** Shown once Auth0 accepts a password reset; Auth0 picks reset or invite wording itself. */
export const AUTH0_PASSWORD_RESET_SENT_MESSAGE = 'Password reset email sent. It comes from Jewelers Mutual (Auth0);'
  + ' if the user was never activated it will be an invitation to set their password.';

/** Shown when the password reset email could not be sent and the JXP API gave no reason. */
export const AUTH0_PASSWORD_RESET_FAILED_MESSAGE = 'The password reset email could not be sent. Please try again later.';

/**
 * The JXP API's own error message when it sent one: it already says what went wrong in terms a
 * representative can act on (not configured, unavailable, not permitted).
 */
export function jxpErrorMessage(error: HttpErrorResponse, fallback: string): string {
  const message = error?.error?.error;
  return typeof message === 'string' && message.length > 0 ? message : fallback;
}
